import React, { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { GroupOrderModal } from '@order/features-group-ordering';

import { GroupOrderShareContent, NotFoundView } from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderShareScreen = () => {
  const router = useRouter();
  const { joinCode } = useLocalSearchParams<GroupOrderShareScreenParams>();

  // ─── Handlers ─────────────────────────────────────────────────────────

  const navigateToBag = useCallback(() => {
    router.replace('/bag');
  }, [router]);

  const closeScreen = useCallback(() => {
    router.back();
  }, [router]);

  // ─────────────────────────────────────────────────────────────────────

  if (!joinCode) return <NotFoundView />;

  return (
    <GroupOrderModal onClose={closeScreen}>
      <GroupOrderShareContent joinCode={joinCode} onClose={closeScreen} onDone={navigateToBag} />
    </GroupOrderModal>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GroupOrderShareScreenParams = {
  joinCode?: string;
};
